/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Stikk = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M113.4.1H14.7C6.7.1.1 6.7.1 14.7v98.8c0 8 6.6 14.6 14.6 14.6h98.8c8 0 14.6-6.6 14.6-14.6V14.7C128 6.7 121.4.1 113.4.1zM64 107.8c-24.2 0-43.7-19.5-43.7-43.7S39.9 20.3 64 20.3s43.7 19.5 43.7 43.7-19.5 43.8-43.7 43.8z" />
    <circle cx={40.9} cy={64} r={7.1} />
    <circle cx={87.2} cy={64} r={7.1} />
  </svg>
);

export default extendIcon(Stikk);
